module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Equivalent Ranks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When visiting German military cemeteries it can be confusing when trying to understand the various ranks of the soldiers buried there. In this sector of the Western Front you will also find the large Portuguese cemetery near Neuve Chapelle and the Indian Memorial close by, each with their individual ranking system. In addition, you will often find German and Indian headstones in CWGC cemeteries. To that end we have produced a rough guide to equivalent ranks which should assist you when visiting the cemeteries and memorials referred to in the guidebook.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f013-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1061da41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/16_fm0211.vue
// module id = 105
// module chunks = 0